export class ClientCredential {

    UserId: string;

    UserToken: string;

    TeamId: string;

    EventId: number;

    EventName: string;

    GroupIds: number[] = [];

    constructor(userId: string, userToken: string, teamId: string,  EventId: number, EventName: string, GroupIds: number[]) {
        this.UserId = userId;
        this.UserToken = userToken;
        this.TeamId = teamId;
        this.EventId = EventId;
        this.EventName = EventName;
        this.GroupIds = GroupIds;
    }
}